import styled from 'styled-components';

export const StyledIcon = styled.svg<{ color?: string }>`
  width: 20px;
  height: 20px;
  color: ${({ color }) => color};
`;

// We use a span+role=button instead of a button go prevent automatic click when used inside a label.
export const StyledButton = styled.span`
  position: relative;
  // For Safari as it show role="button" as buttons
  appearance: none;
  display: inline-block;
  width: 44px;
  height: 44px;
  background: transparent;
  border: 0;
  cursor: pointer;
  padding: 12px;
  margin: -12px;
  box-sizing: border-box;

  &:focus:not(:disabled),
  &:active:not(:disabled) {
    outline: 0;
  }

  &:after {
    content: '';
    position: absolute;
    display: block;
    top: 14px;
    left: 14px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.white};
    z-index: 0;
  }

  &:focus-visible:after, &:focus:after {
    box-shadow: ${({ theme }) => theme.boxShadows?.focus};
  }

  &:focus:not(&:focus-visible):after {
    box-shadow: none;
  }

  ${StyledIcon} {
    position: relative;
    z-index: 1;
  }
`;
